import styled from 'styled-components';

export const InvestmentPaymentCardStyles = styled.div`
	padding: 0.5rem 0.5rem 0.75rem;

	.loans {
		margin-top: 0.5rem;
	}

	.progress-bar {
		overflow: hidden;
		height: 0.5rem;
		border-radius: 0.25rem;

		figure {
			display: block;
			height: 100%;
		}

		&-cash {
			background: ${({ theme }) => theme.v3.colors.teal[8]};
		}

		&-loan {
			background: ${({ theme }) => theme.v3.colors.violet[8]};
		}
	}

	.payment-item {
		margin-top: 0.5rem;
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		padding: 0.5rem 0.5rem 0;

		figure {
			display: inline-block;
			width: 0.5rem;
			height: 0.5rem;
			margin: 0 0.5rem 0 0.25rem;
			border-radius: 50%;
			background: ${({ theme }) => theme.v3.colors.gray[9]};
		}

		&-label {
			display: flex;
			align-items: center;
		}
	}
`;

export const InvestmentPaymentStatusDropdownStyles = styled.div`
	.target {
		height: 2rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		padding: 0.25rem 0.75rem 0.25rem 0.5rem;
		cursor: pointer;
		user-select: none;

		&-icon {
			margin-left: 1rem;
		}
	}

	.menu-label {
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	}
`;
